import { render } from "./EmployeePositionInfo.vue?vue&type=template&id=68617330&scoped=true"
import script from "./EmployeePositionInfo.vue?vue&type=script&lang=js"
export * from "./EmployeePositionInfo.vue?vue&type=script&lang=js"

import "./EmployeePositionInfo.vue?vue&type=style&index=0&id=68617330&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68617330"]])

export default __exports__